import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { shopBundlesEnablePurchaseSimulation } from './match2-shopbundles.utils';

const MATCH2_SHOP_BUNDLES = 'match2 Shop Bundles';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_SHOP_BUNDLES] = [
    {
      text: 'Reset Shop Bundles',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_shopBundlesReset();
      },
    },
    {
      text: 'Clear Powerups',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_shopBundlesClearPowerups();
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_SHOP_BUNDLES:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2ShopBundlesCheats = {
  list,
  ui,
};
